import { finitePercent } from './reportMarket'

export function parseStockRows(text, allowNameOnly = false) {
  const pattern = /([^\s[\]()（）<>，,;；:：]+)\s*[（(](\d{6})[)）](?:\s*([+-]?\d+(?:\.\d+)?%))?/g
  const matches = Array.from(text.matchAll(pattern))
  const clean = value => value.replace(/^[\s[\]，,;；:：、-]+|[\s[\]，,;；、-]+$/g, '').trim()
  if (allowNameOnly) {
    const tokens = text.trim().split(/[、，,;；\n]+/).map(clean).filter(Boolean)
    const rows = tokens.map(token => {
      const parsed = parseStockRows(token)
      if (parsed.rows.length === 1 && !parsed.notes && !parsed.rows[0].description) return parsed.rows[0]
      return /^[\u3400-\u9fffA-Za-z0-9*·.-]{2,20}$/.test(token) && !/^(无|暂无|无其他标的|暂无其他标的)$/.test(token)
        ? { name: token, code: '', originalPct: null, description: '' } : null
    })
    if (rows.length && rows.every(Boolean)) {
      const seen = new Set()
      return { notes: '', rows: rows.filter(row => {
        const key = row.code || row.name
        if (seen.has(key)) return false
        seen.add(key)
        return true
      }) }
    }
  }
  return {
    notes: clean(matches.length ? text.slice(0, matches[0].index) : text),
    rows: matches.map((match, index) => ({
      name: match[1].replace(/^[-•·]+/, ''), code: match[2],
      originalPct: match[3] ? finitePercent(match[3].slice(0, -1)) : null,
      description: clean(text.slice(match.index + match[0].length, matches[index + 1] ? matches[index + 1].index : text.length))
    }))
  }
}

export function extractReportStockTables(html) {
  const container = document.createElement('div')
  container.innerHTML = html
  const markers = Array.from(container.querySelectorAll('.stock-badge, .other-badge'))
  if (!markers.length) return { html, groups: [] }
  const groups = markers.map((marker, index) => {
    const range = document.createRange()
    range.setStartAfter(marker)
    if (markers[index + 1]) range.setEndBefore(markers[index + 1])
    else range.setEnd(container, container.childNodes.length)
    const body = document.createElement('div')
    body.appendChild(range.cloneContents())
    body.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode('\n')))
    return { title: marker.classList.contains('stock-badge') ? '核心标的' : '其他标的', ...parseStockRows(body.textContent, marker.classList.contains('other-badge')) }
  })
  if (!groups.some(group => group.rows.length)) return { html, groups: [] }
  const stockContent = document.createRange()
  stockContent.setStartBefore(markers[0])
  stockContent.setEnd(container, container.childNodes.length)
  stockContent.deleteContents()
  return { html: container.innerHTML, groups }
}
